import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StringUtilService {

  public isBlank(str: string): boolean {
    return !str || str.trim().length === 0;
  }

  public isNotBlank(str: string): boolean {
    return !this.isBlank(str);
  }

  public joinIfNotBlank(values: string[]): string {
    if (values && values.length > 0) {
      return values.filter(value => this.isNotBlank(value)).join(', ');
    }
    return '';
  }
}
